/* ================================
GLOBAL CSS
================================ */

import "./App.css";

/* ================================
REACT ROUTER
================================ */

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import ScrollToTop from "./Client/Pages/ScrollToTop";

/* ================================
CLIENT IMPORTS
================================ */

import Navbar from "./Client/Layouts/Navbar";
import Footer from "./Client/Layouts/Footer";

import Home from "./Client/Pages/Home";
import Contact from "./Client/Pages/Contact";
import ProductDetails from "./Client/Pages/ProductDetails";
import HouseRentDetails from "./Client/Pages/HouseRentDetails";
import Wishlist from "./Client/Pages/Wishlist";
import Register from "./Client/Pages/Register";
import Login from "./Client/Pages/Login";
import Machine from "./Client/Pages/Machine";
import House from "./Client/Pages/House";
import Designer from "./Client/Pages/Designer";
import DesignerDetails from "./Client/Pages/DesignerDetails";
import About from "./Client/Pages/About";

/* ================================
USER IMPORTS
================================ */

import UserSidebar from "./User/layouts/Sidebar";
import UserHeader from "./User/layouts/UserHeader";

import UserDashboard from "./User/Pages/Dashboard";
import AddMachine from "./User/Pages/Addmachine";
import AddDesigner from "./User/Pages/AddDesigner";
import ViewDesigner from "./User/Pages/ViewDesigner";
import Addworkspace from "./User/Pages/Addworkspace";

import Profile from "./User/Pages/Profie";
import ChangePassword from "./User/Pages/ChangePassword";
import Logout from "./User/Pages/Logout";
import ViewMachine from "./User/Pages/ViewMachine";
import ViewWorkspace from "./User/Pages/ViewWorkspace";

/* ================================
ADMIN IMPORTS
================================ */

import AdminSidebar from "./Admin/layouts/Sidebar";
import AdminHeader from "./Admin/layouts/UserHeader";

import AdminDashboard from "./Admin/Pages/Dashboard";
import AdminAddMachine from "./Admin/Pages/Addmachine";
import AdminAddDesigner from "./Admin/Pages/AddDesigner";
import AdminAddworkspace from "./Admin/Pages/Addworkspace";

import Viewmachine from "./Admin/Pages/Viewmachine";
import Viewdesigner from "./Admin/Pages/Viewdesigner";
import Viewworkspace from "./Admin/Pages/Viewworkspace";

import Pendingmachine from "./Admin/Pages/Pendingmachine";
import Pendingdesigner from "./Admin/Pages/Pendingdesigner";
import Pendingworkspace from "./Admin/Pages/Pendingworkspace";

import Manageuser from "./Admin/Pages/Manageuser";
import AdminProfile from "./Admin/Pages/Profie";
import AdminChangePassword from "./Admin/Pages/ChangePassword";
import AdminLogout from "./Admin/Pages/Logout";

import Orders from "./Admin/Pages/Orders";

/* ================================
LAYOUT HANDLER
================================ */

import ProtectedRoute from "./ProtectedRoute"; // Import the protector
import ContactMsg from "./Admin/Pages/ContactMsg";
import SearchResults from "./Client/Pages/Searchresult";
import AddDesign from "./Admin/Pages/AddDesign";
import ViewDesign from "./Admin/Pages/ViewDesign";
import Desingnes from "./Client/Pages/Desingnes";
import DesigneDetails from "./Client/Pages/DesigneDetails";
import Cart from "./Client/Pages/Cart";
import MyOrders from "./Client/Pages/Orders";
import OrderDetails from "./Client/Pages/Orderdtails";
import Hideworkspace from "./Admin/Pages/Hideworkspace";
import Hidemachine from "./Admin/Pages/Hidemachine";
import ForgotPassword from "./Client/Pages/ForgotPassword";
import PageTitle from "./PageTitle";
import AdsPlanManager from "./Admin/Pages/AdsPlanManager";

function Layout() {
  const location = useLocation();
  const isUser = location.pathname.startsWith("/user");
  const isAdmin = location.pathname.startsWith("/admin");

  /* ================================
     CLIENT LAYOUT (Public)
     ================================ */
  if (!isUser && !isAdmin) {
    return (
      <>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/productdetails/:id" element={<ProductDetails />} />
          <Route path="/houserentdetails/:id" element={<HouseRentDetails />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/machine" element={<Machine />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/house" element={<House />} />
          <Route path="/designer" element={<Designer />} />
          <Route path="/designerdetails/:id" element={<DesignerDetails />} />
          <Route path="/designe-details/:id" element={<DesigneDetails />} />
          <Route path="/about" element={<About />} />
          <Route path="/profile" element={<clientProfile />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/designes" element={<Desingnes />} />
          <Route path="/cart" element={<Cart />} />
          <Route path="/myorders" element={<MyOrders />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/order-details" element={<OrderDetails />} />
        </Routes>
        <Footer />
      </>
    );
  }

  /* ================================
     USER PANEL (Protected)
     ================================ */
  if (isUser) {
    return (
      <ProtectedRoute allowedAccountType="provider">
        {" "}
        {/* Only 'user' role can enter */}
        <UserSidebar />
        <div className="main-content">
          <UserHeader />
          <div className="dashboard-content">
            <Routes>
              <Route path="/user" element={<UserDashboard />} />
              <Route path="/user/dashboard" element={<UserDashboard />} />
              <Route path="/user/add-machine" element={<AddMachine />} />
              <Route path="/user/add-designer" element={<AddDesigner />} />
              <Route path="/user/view-machine" element={<ViewMachine />} />
              <Route path="/user/view-designer" element={<ViewDesigner />} />
              <Route path="/user/view-workspace" element={<ViewWorkspace />} />
              <Route path="/user/add-workspace" element={<Addworkspace />} />

              <Route path="/user/profile" element={<Profile />} />
              <Route
                path="/user/change-password"
                element={<ChangePassword />}
              />
              <Route path="/user/logout" element={<Logout />} />
            </Routes>
          </div>
        </div>
      </ProtectedRoute>
    );
  }

  /* ================================
     ADMIN PANEL (Strict Protection)
     ================================ */
  if (isAdmin) {
    return (
      <ProtectedRoute allowedRole="admin">
        {" "}
        {/* Only 'admin' role can enter */}
        <AdminSidebar />
        <div className="main-content">
          <AdminHeader />
          <div className="dashboard-content">
            <Routes>
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/add-machine" element={<AdminAddMachine />} />
              <Route
                path="/admin/add-designer"
                element={<AdminAddDesigner />}
              />
              <Route
                path="/admin/add-workspace"
                element={<AdminAddworkspace />}
              />
              <Route path="/admin/view-machine" element={<Viewmachine />} />
              <Route path="/admin/view-designer" element={<Viewdesigner />} />
              <Route path="/admin/view-workspace" element={<Viewworkspace />} />
              <Route
                path="/admin/pending-machine"
                element={<Pendingmachine />}
              />
              <Route
                path="/admin/pending-designer"
                element={<Pendingdesigner />}
              />
              <Route
                path="/admin/pending-workspace"
                element={<Pendingworkspace />}
              />
              <Route path="/admin/users" element={<Manageuser />} />
              <Route path="/admin/hide-machine" element={<Hidemachine />} />
              <Route path="/admin/hide-workspace" element={<Hideworkspace />} />
              <Route path="/admin/profile" element={<AdminProfile />} />
              <Route path="/admin/contactmsg" element={<ContactMsg />} />
              <Route
                path="/admin/change-password"
                element={<AdminChangePassword />}
              />
              <Route path="/admin/add-design" element={<AddDesign />} />
              <Route path="/admin/view-design" element={<ViewDesign />} />
              <Route path="/admin/logout" element={<AdminLogout />} />
              <Route path="/admin/orders" element={<Orders />} />
              <Route path="/admin/ads-plan" element={<AdsPlanManager />} />
            </Routes>
          </div>
        </div>
      </ProtectedRoute>
    );
  }
}

/* ================================
MAIN APP
================================ */

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageTitle />
      <Layout />
    </BrowserRouter>
  );
}

export default App;
